import { render } from "./Tabbar.vue?vue&type=template&id=66de90a4&scoped=true&ts=true"
import script from "./Tabbar.vue?vue&type=script&lang=ts"
export * from "./Tabbar.vue?vue&type=script&lang=ts"

import "./Tabbar.vue?vue&type=style&index=0&id=66de90a4&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66de90a4"]])

export default __exports__